import React, { Fragment } from 'react'
import { number, string, array, bool, func } from 'prop-types'
import InfiniteScroll from 'react-infinite-scroller'
import withResults from '../hoc/withResults'
import { FOLDERS, EMPTY_OBJECT } from '../utils/constants'
import Folder from '../components/search-objects/folders/Folder'
import Loader from '../components/ui/loader/Loader'
import ResultsEmptyState from '../components/results/EmptyState'

const initialLoad = false
const LOADER_KEY = 'loader-key'

const ScreensResultsFolders = ({
  lastQueryUsed,
  query,
  site,
  results,
  error,
  resultsAreLoading,
  hasMore = false,
  requestResults,
  pageStart = 1
}) => {
  const renderResultsItem = (item = EMPTY_OBJECT, index) =>
    <Folder {...item} index={index} lastUpdate={item.last_update} key={index} query={query} />
  const items = results.map((item, index) => renderResultsItem(item, index))

  const loadItems = page => {
    if (hasMore) {
      requestResults(query, page, true)
    }
  }
  return (
    <Fragment>
      {items.length === 0 && resultsAreLoading && (
        <Loader key={LOADER_KEY} />
      )}
      {items.length === 0 && !resultsAreLoading && (
        <ResultsEmptyState query={query} site={site} />
      )}
      {!error && items.length > 0 && (
        <div className='folders-container'>
          <InfiniteScroll
            pageStart={pageStart}
            loadMore={loadItems}
            hasMore={hasMore && !resultsAreLoading}
            initialLoad={initialLoad}
            loader={<Loader key={LOADER_KEY} />}>
            {items}
          </InfiniteScroll>
        </div>
      )}
    </Fragment>
  )
}

ScreensResultsFolders.propTypes = {
  lastQueryUsed: string,
  query: string,
  site: string,
  results: array,
  error: bool,
  resultsAreLoading: bool,
  hasMore: bool,
  requestResults: func,
  pageStart: number
}

export default withResults(ScreensResultsFolders, FOLDERS)
